import { getGlobalHeadersAsObject } from "../global-headers";

export interface AssignmentLlmQueueStat {
	assignment_id: number;
	llm_queue_count: number;
}

export async function getAssignmentLlmQueueStats(
	assignmentIds: number[]
): Promise<AssignmentLlmQueueStat[]> {
	if (assignmentIds.length === 0) {
		return [];
	}

	const response = await fetch(
		`/api/v2/assignment_llm_queue_stats/?assignment_ids=${assignmentIds.join(",")}`,
		{
			method: "GET",
			headers: getGlobalHeadersAsObject(),
		}
	);

	if (!response.ok) {
		throw new Error(`Failed to fetch LLM queue stats: ${response.statusText}`);
	}

	return response.json();
}
